import { useLocation, useParams } from "react-router-dom";
import { useAccount, useContact } from "../../hooks/QueryHooks";
import useWorkspaceStore from "../../store/workspace/workspaceStore";
import AccountCrumbs from "../../pages/home/account-details/components/AccountCrumbs";

const UserViewHeaderContent = () => {
  const { accountId, userId }: any = useParams();
  const location = useLocation();
  const workspaceId = useWorkspaceStore((state) => state.workspace?.id);
  
  // Extract accountId from URL if it's not in params (for view-based user routes)
  const extractedAccountId = accountId || (() => {
    // For routes like /home/{workspaceId}/view/{viewId}/user/{userId}
    const viewUserMatch = location.pathname.match(/\/home\/[\w\d]+\/view\/([\w\d-]+)\/user\/[\w\d-]+/i);
    if (viewUserMatch) {
      // In this case, we don't have a direct accountId, so we'll leave it undefined
      // The AccountCrumbs component will handle this case appropriately
      return undefined;
    }
    return null;
  })();
  
  const { data: accountData }: any = useAccount({
    workspaceId,
    accountId: extractedAccountId || accountId,
    enabled: !!(extractedAccountId || accountId) && !!workspaceId,
  });

  const { data: userData }: any = useContact({
    workspaceId,
    contactId: userId,
    enabled: !!userId && !!workspaceId,
  });

  return (
    <AccountCrumbs 
      accountName={accountData?.name} 
      userName={userData?.name}
    />
  );
};

export default UserViewHeaderContent;
